/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'print-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M19 9H6V1.5A1.5 1.5 0 0 1 7.5 0h10A1.5 1.5 0 0 1 19 1.5zm5 2.5v9a1.5 1.5 0 0 1-1.5 1.5H20v-3h1.5a.5.5 0 0 0 0-1h-18a.5.5 0 0 0 0 1H5v3H2.5A1.5 1.5 0 0 1 1 20.5v-9A1.5 1.5 0 0 1 2.5 10h20a1.5 1.5 0 0 1 1.5 1.5zm-17 2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .5-.5zm-1 10a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V19H6z"/>'
  }
})
